import { Locale } from 'modules/domains/template';
import { Trans } from 'services/i18n';
import { BannerVariants } from 'ui/banner/types';
import { WarningFill } from 'ui/icons';
import { Nullish } from 'utils/tsHelpers';

import { useTranslations } from '../../../hooks/useTranslations';
import { DEFAULT_LOCALE_SELECT_TEST_IDS } from '../DefaultLocaleSelectFormField.constants';
import { StyledBanner } from '../DefaultLocaleSelectFormField.styled';

export const NoDefaultLocaleBanner = ({
  templateDefaultLocale,
}: {
  templateDefaultLocale: Nullish<Locale>;
}) => {
  const { t } = useTranslations();

  return (
    <StyledBanner
      Icon={<WarningFill width={16} height={16} />}
      data-test={DEFAULT_LOCALE_SELECT_TEST_IDS.bannerSettingDisabled}
      variant={BannerVariants.WARNING}
    >
      <Trans
        t={t}
        i18nKey="banner.localeSettingDisabled"
        components={{
          bold: <strong />,
          paragraph: <p />,
        }}
        values={{
          languageName: templateDefaultLocale?.languageName,
          tag: templateDefaultLocale?.tag,
        }}
      >
        <p>
          This project has turned off the ability to set a default locale in each template and this
          template is using default different than your project locale default.
        </p>
        <p>
          If you change your default to your project default, you will not be able to change back to{' '}
          <strong>
            {templateDefaultLocale?.languageName} {templateDefaultLocale?.tag}
          </strong>
          .
        </p>
      </Trans>
    </StyledBanner>
  );
};
